import { compose, withProps } from 'recompose';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { withTheme } from 'styled-components';

import {
    storeActive as activeStoreSelector,
    currentLanguage as currentLanguageSelector,
} from 'ggApp/modules/store/selectors';
import { isLoggedIn as isLoggedInSelector } from 'ggApp/modules/auth/selectors';

import HomeLink from './HomeLink';

const enhance = compose(
    connect(
        createStructuredSelector({
            activeStore: activeStoreSelector,
            isLoggedIn: isLoggedInSelector,
            locale: currentLanguageSelector,
        }),
    ),
    withProps(({ activeStore: { code }, locale }) => ({
        isBusinessStore: code.startsWith('business'),
        storeCode: code,
        language: locale,
    })),
    withTheme,
);

export default enhance(HomeLink);
